import { isFuture, isPast, secondsToMilliseconds } from 'date-fns';

export default function isCUEndDateValid(
    endTime?: number,
    catchupEndTime?: number,
) {
    return !!(
        endTime &&
        isPast(secondsToMilliseconds(endTime)) &&
        catchupEndTime &&
        isFuture(secondsToMilliseconds(catchupEndTime))
    );
}
